// extracted by mini-css-extract-plugin
export default {"leaderboard":"Leaderboard_leaderboard__55p9i","dark":"Leaderboard_dark__-bqZW"};